const ExchangeIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M8.16663 0.583212C8.55071 0.579391 8.9317 0.652224 9.28729 0.797448C9.64288 0.942671 9.96593 1.15737 10.2375 1.42897C10.5091 1.70057 10.7238 2.02362 10.8691 2.37921C11.0143 2.73481 11.0871 3.11579 11.0833 3.49988V3.49988'
      stroke='#442E83'
      strokeWidth='1.16667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M2.91665 10.4999C2.91283 10.884 2.98566 11.265 3.13088 11.6205C3.27611 11.9761 3.4908 12.2992 3.7624 12.5708C4.03401 12.8424 4.35706 13.0571 4.71265 13.2023C5.06824 13.3475 5.44923 13.4204 5.83331 13.4165V13.4165'
      stroke='#442E83'
      strokeWidth='1.16667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M12.8333 9.33331H8.74996C8.59525 9.33331 8.44688 9.30495 8.33748 9.25446C8.22808 9.20397 8.16663 9.13549 8.16663 9.06408V6.10254C8.16663 6.03114 8.22808 5.96266 8.33748 5.91217C8.44688 5.86168 8.59525 5.83331 8.74996 5.83331H12.8333C12.988 5.83331 13.1364 5.86168 13.2458 5.91217C13.3552 5.96266 13.4166 6.03114 13.4166 6.10254V9.06408C13.4166 9.13549 13.3552 9.20397 13.2458 9.25446C13.1364 9.30495 12.988 9.33331 12.8333 9.33331Z'
      fill='#A197C1'
    />
    <path
      d='M5.25004 8.16665H1.16671C1.012 8.16665 0.863625 8.13355 0.754228 8.07465C0.644832 8.01574 0.583374 7.93585 0.583374 7.85254V4.39742C0.583374 4.31411 0.644832 4.23422 0.754228 4.17531C0.863625 4.11641 1.012 4.08331 1.16671 4.08331H5.25004C5.40475 4.08331 5.55312 4.11641 5.66252 4.17531C5.77192 4.23422 5.83337 4.31411 5.83337 4.39742V7.85254C5.83337 7.93585 5.77192 8.01574 5.66252 8.07465C5.55312 8.13355 5.40475 8.16665 5.25004 8.16665Z'
      fill='#A197C1'
    />
    <path
      d='M5.25004 8.16665H1.16671C1.012 8.16665 0.863625 8.10519 0.754228 7.99579C0.644832 7.8864 0.583374 7.73802 0.583374 7.58331V1.16665C0.583374 1.01194 0.644832 0.863564 0.754228 0.754167C0.863625 0.644771 1.012 0.583313 1.16671 0.583313H5.25004C5.40475 0.583313 5.55312 0.644771 5.66252 0.754167C5.77192 0.863564 5.83337 1.01194 5.83337 1.16665V7.58331C5.83337 7.73802 5.77192 7.8864 5.66252 7.99579C5.55312 8.10519 5.40475 8.16665 5.25004 8.16665Z'
      stroke='#442E83'
      strokeWidth='1.16667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M0.583374 5.83319H5.83337'
      stroke='#442E83'
      strokeWidth='1.16667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M12.8333 13.4165H8.74996C8.59525 13.4165 8.44688 13.3551 8.33748 13.2457C8.22808 13.1363 8.16663 12.9879 8.16663 12.8332V6.41652C8.16663 6.26181 8.22808 6.11344 8.33748 6.00405C8.44688 5.89465 8.59525 5.83319 8.74996 5.83319H12.8333C12.988 5.83319 13.1364 5.89465 13.2458 6.00405C13.3552 6.11344 13.4166 6.26181 13.4166 6.41652V12.8332C13.4166 12.9879 13.3552 13.1363 13.2458 13.2457C13.1364 13.3551 12.988 13.4165 12.8333 13.4165Z'
      stroke='#442E83'
      strokeWidth='1.16667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M8.16663 11.0832H13.4166'
      stroke='#442E83'
      strokeWidth='1.16667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default ExchangeIcon
